import React from 'react'
import Footer from '../component/Footer'

const Blog = () => {
    return (


        <>

            <div className='heading'>
                <br />
                <p>Our  Blog</p>
            </div>

            <Footer />
        </>
    )
}

export default Blog